export const getFormData = data => {
  const fd = new FormData();
  Object.keys(data).forEach(key => fd.append(key, data[key]));

  return fd;
};
